


export interface MenuBlockItemCollection{
    blocks:MenuBlockItem[],
}


export interface MenuBlockItem{
    title:string,
    menuItemCollection:MenuItem[]
}


//MAKE SURE THESE NEVER CHANGE ORDER - JUST ADD NEW ITEMS TO THE BOTTOM
export enum MenuItemType{
    NONE=0,
    STAFF_CREATOR,    
    EXAMPLE_ITEM_1,
    EXAMPLE_ITEM_2,

    ALI_PAGE,
    ALI_SUB_PAGE,
}

export interface MenuItem{
    displayName:string,
    itemRef:string,
    menuItemType:MenuItemType
}



//Add new menu items here with a matching enum value in MenuItemType
export const DefaultMenuBlocks:MenuBlockItemCollection = {
blocks:[
    
    {
        title:"Staff Manager",
        menuItemCollection:[
            {
                displayName:'Staff Creator',
                itemRef:'0da94ff4-fdd7-4288-a3da-f23625d67955',
                menuItemType:MenuItemType.STAFF_CREATOR
            }
        ]
    },


    {
        title:"Ali Page Manager",
        menuItemCollection:[
            {
                displayName:'Ali Page',
                itemRef:'0da94ff4-d347-4288-a3da-f23625d67955',
                menuItemType:MenuItemType.ALI_PAGE
            }
        ]
    },


    {
        title:"Example Menu Items 1",
        menuItemCollection:[
            {
                displayName:'Menu Item 1-1',
                itemRef:'exampleRefUUID',
                menuItemType:MenuItemType.EXAMPLE_ITEM_1
            },
            {
                displayName:'Menu Item 1-2',
                itemRef:'exampleRefUUID',
                menuItemType:MenuItemType.EXAMPLE_ITEM_2
            }
        ]
    },
    {
        title:"Example Menu Items 2",
        menuItemCollection:[
            {
                displayName:'Menu Item 2-1',
                itemRef:'exampleRefUUID',
                menuItemType:MenuItemType.EXAMPLE_ITEM_1
            },
            {
                displayName:'Menu Item 2-2',
                itemRef:'exampleRefUUID',
                menuItemType:MenuItemType.EXAMPLE_ITEM_2
            }
        ]
    }
]
}


